// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fC","catalogByServiceItem__title":"c-k_fE"};